export const ADMIN_UID = "4c045c22-135f-4bb3-a5ba-5b5c823bbc3a";

export function isAdmin(userId: string | null | undefined) {
  return Boolean(userId && userId === ADMIN_UID);
}
